var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"our-clients"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"our-clients-container"},[_c('div',{staticClass:"left-side"},[_c('div',{staticClass:"heading"},[_vm._v("Our Clients")]),_c('div',{staticClass:"text"},[_vm._v(" Several selected clients, who already believe in our service. ")])]),_c('div',{staticClass:"right-side"})])])])
}]

export { render, staticRenderFns }